export default {
  // ========== Acciones comunes ==========
  add: 'Agregar',
  apply: 'Aplicar',
  edit: 'Editar',
  delete: 'Eliminar',
  save: 'Guardar',
  saving: 'Guardando...',
  create: 'Crear',
  cancel: 'Cancelar',
  close: 'Cerrar',
  closeEntity: 'Cerrar {entity}',
  open: 'Abrir',
  openEntity: 'Abrir {entity}',
  search: 'Buscar',
  filter: 'Filtrar',
  export: 'Exportar',
  import: 'Importar',
  select: 'Seleccione',
  copy: 'Copiar',
  goTo: 'Ir a',
  show: 'Mostrar',
  view: 'Ver',
  hide: 'Ocultar',
  modify: 'Modificar',
  download: 'Descargar',
  and: 'y',
  accept: 'Aceptar',
  continue: 'Continuar',
  complete: 'Completa',
  contact: 'Contacta',

  // ========== Tooltips comunes ==========
  addTooltip: 'Agregar {entity}',
  createTooltip: 'Crear {entity}',
  editTooltip: 'Editar {entity}',
  modifyTooltip: 'Modificar {entity}',
  deleteTooltip: 'Eliminar {entity}',
  saveTooltip: 'Guardar {entity}',
  viewTooltip: 'Ver {entity}',
  viewDetails: 'Ver Detalles',
  updateTooltip: 'Actualizar {entity}',
  copyTooltip: 'Copiar {entity}',
  goToTooltip: 'Ir a {entity}',
  publishTooltip: 'Publicar {entity}',
  replicateTooltip: 'Replicar {entity}',
  showTooltip: 'Mostrar {entity}',

  // ========== Títulos de modales ==========
  editModalTitle: 'Editar {entity}',
  editDescription: 'Editar Descripción',
  createModalTitle: 'Crear {entity}',
  viewModalTitle: 'Ver {entity}',
  deleteModalTitle: 'Eliminar {entity}',
  copyModalTitle: 'Copia del {entity}',

  // ========== Confirmaciones de eliminación ==========
  deleteConfirmTitle: '¿Está seguro de que desea eliminar esta instancia de "{entity}"?',
  deleteConfirmTitle2: '¿Está seguro de que desea eliminar {article} {entity}?',
  deleteConfirm: '¿Está seguro de que desea eliminar?',
  deleteConfirmText: '¡Esta acción no se podrá revertir!',
  toBeDeleted: 'que se eliminarán',

  // ========== Mensajes de Confirmaciones ==========
  sureToApplyChanges: '¿Está seguro de aplicar los cambios?',

  // ========== Mensajes de éxito ==========
  created: 'creada.',
  updated: 'actualizada.',
  deleted: 'eliminada.',
  deletedSuccessfully: '{entity} eliminado.',
  deletedSuccessfully2: 'Se eliminó el {entity}.',
  saved: 'guardada.',

  // ========== Validaciones comunes ==========
  required: 'Este campo es obligatorio',
  optionalField: 'Este campo es opcional',
  requiredMinLength: 'Este campo es obligatorio y debe tener al menos {min} caracteres.',
  minLength: 'Este campo debe tener al menos {min} caracteres.',
  maxLength: 'Este campo no puede tener más de {max} caracteres.',
  numeric: 'Este campo debe ser numérico.',
  greaterThanZero: 'Este campo debe ser mayor a 0',
  notBeLessThanZero: 'Este campo no debe ser menor a 0.',
  greaterThanOrEqualToZero: 'Este campo debe ser mayor o igual a 0.',
  requiredAndGreaterThanZero: 'Este campo es obligatorio y debe ser mayor de 0.',
  integerGreaterThanZero: 'Este campo debe ser un entero mayor a cero.',
  numericAndGreaterThanZero: 'Este campo debe ser numérico y mayor a 0',
  email: 'Debe ingresar un correo electrónico válido.',
  hoursAvailable: 'Horas disponible',
  mustEnterHourGreaterOrEqualZero: 'Debe ingresar una hora mayor o igual a 0',
  cannotExceedHours: 'y no puede superar {hours} horas.',
  mustEnterScoreGreaterThanZero: 'Debe ingresar un puntaje mayor a 0.',
  mustSelectedAtLeast: 'Debe seleccionar al menos {min} {entity}',

  // ========== Selectores ==========
  selectOption: 'Seleccione una {entity}',
  selectOneOrMany: 'Seleccione uno o varios {entity}',
  selectOneOrManyOnly: "Seleccione uno o varios",
  selectOneOrManyFeminine: 'Seleccione una o varias {entity}',
  mustSelect: 'Debe seleccionar {entity}.',
  noOptions: 'No se encontraron resultados para:',
  noCreated: 'No cuenta con {entity} creados',
  thisNoCreated: 'Este {entity1} no cuenta con {entity2} creados',

  // ========== Tabla/Grid ==========
  order: 'Orden',
  numberAbbreviation: 'N°',
  name: 'Nombre',
  rut: 'Rut', // Este campo hay que modificarlo, ya que se muestra el tipo de documento en este caso rut pero a futuro deberia haber otro
  description: 'Descripción',
  user: 'Usuario',
  identifier: 'Identificador',
  email2: 'Email',
  role: 'Rol',
  address: 'Dirección',
  cohort: 'Cohorte',
  actions: 'Acciones',
  start: 'Inicio',
  end: 'Término',
  date: 'Fecha',
  startDate: 'Fecha de Inicio',
  endDate: 'Fecha de Término',
  color: 'Color',
  credit: 'Crédito',
  noData: 'No hay datos disponibles',
  loading: 'Cargando...',
  loadingLongProcess: 'Este proceso puede tardar unos minutos. Por favor, espere.',
  searchPlaceholder: 'Buscar...',
  clear: 'Limpiar',
  pressEnterToAddFilter: 'Presione Enter Para Agregar un Filtro',
  removeFilter: 'Eliminar Filtro',
  displayColumns: 'Visualizar columnas',
  filterBy: 'Filtrar por',
  deselectAllToFilter: 'Deseleccionar todos para filtrar por toda la información de la tabla.',
  noDataToShow: 'No hay datos para mostrar.',
  noDataContextToShow: 'No hay {entity} para mostrar.',
  noMatchingData: 'No hay datos que coincidan con su búsqueda.',
  showing: 'Mostrando',
  of: 'de',
  rowsTotal: 'filas en total.',
  perPage: 'Por página:',
  perPageTooltip: 'Cantidad de elementos que se van a mostrar por página.',
  selectLabel: 'Seleccionar',
  selectAll: 'Seleccionar todos',
  deselectAll: 'Deseleccionar todos',
  selected: 'Seleccionados',
  removeSelected: 'Remover seleccionado',
  clearSelected: 'Limpiar seleccionados',
  addSelected: 'Agregar seleccionados',
  available: 'Disponibles',
  assigned: 'Asignados',
  addUser: 'Agregar usuario',
  showAll: 'Mostrar todos',
  hideAll: 'Ocultar todos',
  common: 'Común',
  code: 'Código',
  isInstitutional: 'Es institucional',

  // ========== Mensajes generales ==========
  success: 'Éxito',
  error: 'Error',
  errorOccurred: 'Ha ocurrido un error...',
  warning: 'Advertencia',
  info: 'Información',
  noDataFound: 'No se ha encontrado ningún',
  optional: 'Opcional',
  yes: 'Si',
  no: 'No',
  without: 'Sin',
  withoutEntity: 'Sin {entity}',
  with: 'Con',
  withEntity: 'Con {entity}',
  notApplicable: 'N/A',
  showMore: 'Click para ver más',
  showLess: 'Click para ver menos',
  seeMore: 'Ver más',
  seeLess: 'Ver menos',
  title: 'Título',


  // ========== Guardando información ==========
  savingInfo: 'Guardando información...',
  savingInfoText: 'Por favor espere un momento.',
  creatingInfo: 'Creando...',
  creatingInfoText: 'Por favor espere un momento.',
  updatingInfo: 'Actualizando...',
  updatingInfoText: 'Por favor espere un momento.',

  // ========== Mensajes de archivos ==========
  generatingExcel: 'Generando Excel...',
  pleaseWaitFile: 'Por favor, espera mientras se genera el archivo.',
  pleaseWait: 'Por favor, espera mientras se carga.',
  downloadError: 'No se pudo descargar el archivo.',
  generateError: 'No se pudo generar el archivo.',
  problemGenerating: 'Hubo un problema al generar el archivo.',
  file: 'Archivo',
  attachedFile: 'Archivo adjunto',
  fileDeleted: 'Archivo eliminado.',
  sureDeleteAttachedFile: '¿Está seguro de que desea eliminar el archivo adjunto?',
  edited: 'Editado',

  // ========== Tiempo ==========
  remainingTime: 'Tiempo Restante',
  hours: 'Horas',
  minutes: 'Minutos',
  seconds: 'Segundos',

  // ========== Idioma ==========
  matterLanguageAutoChanged: 'El idioma se cambió automáticamente porque esta asignatura fue definida en este idioma.',
}
